import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

export const analytics = createReducer(
  {
    allowdAnalyticsList: {},
    isFetchingList: false,
    isListFetched: false,
  },
  {
    [types.GET_ALLOWED_ANALYTICS_REPORT_START](state, action) {
      const newState = Object.assign({}, state, {
        allowdAnalyticsList: {},
        isFetchingList: true,
        isListFetched: false,
      });
      return newState;
    },
    [types.GET_ALLOWED_ANALYTICS_REPORT_FAIL](state, action) {
      const newState = Object.assign({}, state, {
        allowdAnalyticsList: {},
        isFetchingList: false,
        isListFetched: false,
      });
      return newState;
    },
    [types.GET_ALLOWED_ANALYTICS_REPORT_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        allowdAnalyticsList: action.allowedList,
        isFetchingList: false,
        isListFetched: true,
      });
      return newState;
    },
  },
);

export { analytics as default };
